// extracted by mini-css-extract-plugin
module.exports = {"trigger":"ProfileMenu_trigger__1PO8_","avatar":"ProfileMenu_avatar__1RXPM"};